<template>
    <div>
        
        
       <div class="text-center">
            <h3 class="mb-3">Risk Percentage </h3>
            <p>FxView offers a risk calculator to assist users in managing risks by calculating the potential maximum loss that can be incurred by the current open positions and active pending orders.</p>
       </div>
        <div class="verticallyTab mt-5"> 
            <div class="bottomTab w-100">
                <form class="stepForm-contact mt-5">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field">
                                    <option>USD</option>
                                    <option>ETH</option>
                                    <option>BTC</option>
                                    <option>LTC</option>
                                    <option>BCC</option>
                                    <option>XRP</option>
                                </select>
                                <label class="float-label">Account Base Currency</label>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field">
                                    <option>Crypto Currencies</option>
                                    <option>Currencies</option>
                                    <option>Commodities</option>
                                    <option>Indices</option>
                                </select>
                                <label class="float-label">Currency Pairs</label>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" name="username" class="float-field">
                                <label class="float-label">Open Price</label>
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper text-left">
                                <label class="float-label-custom">Deal Type</label>
                                <div class="d-flex align-items-center">
                                    <label class="custom-radio-button">Buy
                                        <input type="radio" name="radio">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="custom-radio-button">Sell
                                        <input type="radio" name="radio">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" name="username" class="float-field">
                                <label class="float-label">Stop Loss</label>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" name="username" class="float-field">
                                <label class="float-label">Account Balance </label>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" name="username" class="float-field">
                                <label class="float-label">Risk percentage</label>
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <a href="#" class="common_btn">Calculate Now</a>
                                <p class="mt-3">Commision (round trip) : 123.45</p>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        
        <ul class="listResult d-flex flex-wrap text-left">
            <li>
                <p>Segment</p>
                <h4>0.0</h4>
            </li>
            <li>
                <p>Account base currency</p>
                <h4>0.0</h4>
            </li>
            <li>
                <p>Symbol</p>
                <h4>EURUSD</h4>
            </li>
            <li>
                <p>Volume in lots</p>
                <h4>500</h4>
            </li>
            <li>
                <p>Current Conversion Price</p>
                <h4>0.0</h4>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'RiskPercentage',
        data() {
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/risk_percentage.vue